"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDeviceScreen = void 0;
var _mui = require("@ori-ui/mui");
const useDeviceScreen = () => {
  const hasMouse = (0, _mui.useMediaQuery)('(hover: hover) and (pointer: fine)');
  return {
    hasMouse
  };
};
exports.useDeviceScreen = useDeviceScreen;
//# sourceMappingURL=useDeviceScreen.js.map